import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Router from "./pages/Routes";

const App = () => {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
};

export default App;